module.exports = __webpack_public_path__ + "static/20241029.c0af5d78.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/20241029.png
// module id = 1000
// module chunks = 2